import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PageHeader, Spinner, useApiQuery } from '@/modules/common';
import { Routes } from '@/router/routes';

import { AddEventDialog, EventsTable } from '../components';
import { EventType } from '../types';

export const EventsV2Page: FC = () => {
  const navigate = useNavigate();

  const [addEventDialogOpen, setAddEventDialogOpen] = useState(false);

  const { data: eventTypesData, isFetching: isFetchingTypes } = useApiQuery<
    EventType[]
  >(`/events/types`, {
    queryKey: ['eventTypes'],
    initialData: null,
  });

  const redirectToEventDetails = (item) => {
    navigate(`${Routes.Events}/${item.id}`);
  };

  const typesOptions = eventTypesData?.map((type) => ({
    id: type.name,
    value: type.id,
  }));

  return (
    <div>
      <PageHeader
        title="Events"
        actions={[
          <Button
            disabled={isFetchingTypes}
            data-testid="add-new-event-button"
            onClick={() => setAddEventDialogOpen(true)}
            key="new-event"
          >
            <PlusSquareIcon />
            Add new event
          </Button>,
        ]}
      />

      <>
        <EventsTable onClick={redirectToEventDetails} />
        <AddEventDialog
          isOpen={addEventDialogOpen}
          onOpenChange={setAddEventDialogOpen}
          typesOptions={typesOptions}
        />
      </>
    </div>
  );
};
